//THIS IS TEMPORARY -- TODO ???

import { Modal } from "semantic-ui-react";
import Spinner from "./Spinner";

const ViewPdfLauncher = ({ label, pdfData }) => {
    return (
        <Modal
            style={{
                position: "absolute !important", top: "0px", left: "0px", width: "100%",
                height: "100%", padding: "0px !important", margin: "0px !important"
            }}
            className="fullscreenModal"
            trigger={<span style={{ color: "#4183C4", cursor: "pointer" }}>{label}</span>}
            centered={false}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            closeOnDimmerClick={true}
            content={pdfData ?
                <embed src={`data:application/pdf;base64,${pdfData}`}
                    type="application/pdf" width="100%" height="99.6%" />
                :
                <><Spinner /></>}
            actions={[{ key: 'done', content: 'Close', negative: true }]}
        />
    )
}

export default ViewPdfLauncher;